import {
    type TPromoRelease as TApiPromoRelease,
    checkPromoReleaseContainUrl,
    withQuery,
} from '@core/api'
import { convertPromoRelease } from '@core/converters'
import { httpClient } from '@core/http-client'

type TCheckPromoReleaseContainParams = {
    id: string
    type: 'audio' | 'collection'
    signal?: AbortSignal
}

/** Promo releases that would break if the entity were deleted. */
export const checkPromoReleaseContain = async ({
    id,
    type,
    signal,
}: TCheckPromoReleaseContainParams) => {
    const apiReleases = await httpClient
        .get(withQuery(checkPromoReleaseContainUrl(), { id, type }), { signal })
        .json<TApiPromoRelease[]>()

    return apiReleases.map(convertPromoRelease)
}
